import { render, staticRenderFns } from "./HelpdeskQuickSearch.vue?vue&type=template&id=1a023672&scoped=true"
import script from "./HelpdeskQuickSearch.vue?vue&type=script&lang=js"
export * from "./HelpdeskQuickSearch.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskQuickSearch.vue?vue&type=style&index=0&id=1a023672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a023672",
  null
  
)

export default component.exports